import SLIDE1 from './1.png';
import SLIDE2 from './2.png';
import SLIDE3 from './3.png';
import SLIDE4 from './4.png';
import SLIDE5 from './5.png';
import SLIDE6 from './6.png';
import SLIDE7 from './7.png';
import SLIDE8 from './8.png';
import SLIDE9 from './9.png';

export const IMAGES = [
  {
    id: 1,
    name: 'slide1',
    url: SLIDE1,
  },
  {
    id: 2,
    name: 'slide2',
    url: SLIDE2,
  },
  {
    id: 3,
    name: 'slide3',
    url: SLIDE3,
  },
  {
    id: 4,
    name: 'slide4',
    url: SLIDE4,
  },
  {
    id: 5,
    name: 'slide5',
    url: SLIDE5,
  },
  {
    id: 6,
    name: 'slide6',
    url: SLIDE6,
  },
  {
    id: 7,
    name: 'slide7',
    url: SLIDE7,
  },
  {
    id: 8,
    name: 'slide8',
    url: SLIDE8,
  },
  {
    id: 9,
    name: 'slide9',
    url: SLIDE9,
  },
];
